var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('router-link',{attrs:{"to":"/vip/list"}},[_vm._v("golist")]),_c('h1',[_vm._v("INDEX PAGE")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }